import {useEffect, useState} from 'react';
import {ActivitiesSector} from '../../../backend/interfaces/activities-sector';
import {useDailyCareLogFilters} from '../../../contexts/dailycare-log-filters/context';
import CollapsibleCheckbox from './collapsible-checkbox';
import CheckboxSkeleton from './checkbox-skeleton';
import NestedCheckbox from '../../checkbox/nested-checkbox';

interface ActivitiesSectorFilterCollapsibleProps {
  entityId: string;
  activitiesSector: ActivitiesSector;
}

const ActivitiesSectorFilterCollapsible = ({
  entityId,
  activitiesSector,
}: ActivitiesSectorFilterCollapsibleProps) => {
  const [expanded, setExpanded] = useState(false);

  const {
    tasksFilters: {activitiesGroupIds},
    activityGroups,
    fetchActivitiesGroups,
    toggleActivitiesSectorFilter,
    toggleActivitiesGroupFilter,
  } = useDailyCareLogFilters();

  // Get activities groups for this sector
  const activitiesGroups = activityGroups[activitiesSector.id!];

  useEffect(() => {
    if (expanded && !activitiesGroups) {
      fetchActivitiesGroups(entityId, activitiesSector.id!);
    }
  }, [expanded, entityId, activitiesSector, activitiesGroups, fetchActivitiesGroups]);

  const handleActivitiesSectorChange = (checked: boolean) => {
    toggleActivitiesSectorFilter(activitiesSector.id!, checked);
  };

  const handleActivitiesGroupChange = (activitiesGroupId: string, checked: boolean) => {
    toggleActivitiesGroupFilter(activitiesGroupId, checked);
  };

  // The activities sector is checked if at least 1 nested group is checked
  const activitiesSectorChecked =
    activitiesGroups?.some((activitiesGroup) =>
      activitiesGroupIds?.includes(activitiesGroup.id!)
    ) ?? false;

  return (
    <CollapsibleCheckbox
      label={activitiesSector.name}
      checked={activitiesSectorChecked}
      onChange={handleActivitiesSectorChange}
      expanded={expanded}
      toggleExpanded={setExpanded}
    >
      {activitiesGroups
        ? activitiesGroups.map((activitiesGroup) => {
            const groupChecked = activitiesGroupIds?.includes(activitiesGroup.id!) ?? false;

            return (
              <NestedCheckbox
                key={activitiesGroup.id!}
                label={activitiesGroup.name}
                checked={groupChecked}
                onChange={(selected) => handleActivitiesGroupChange(activitiesGroup.id!, selected)}
              />
            );
          })
        : new Array(3).fill(1).map((_item, index) => <CheckboxSkeleton key={index} />)}
    </CollapsibleCheckbox>
  );
};

export default ActivitiesSectorFilterCollapsible;
